import { serviceRequest } from 'utils/http';
import { SiteEmployeeService } from 'common/api';

type CanRegisterBody = {
  email: string;
  token: string;
};

export function canRegisterAPI({ email, ...canRegisterBody }: CanRegisterBody) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerCanRegisterEmail({
      email: email.toLowerCase(),
      ...canRegisterBody,
    })
  );
}
